/* @flow */

import * as React from 'react';
import { translate } from 'react-i18next';

export type TypePropsAcf = {|
  created_at: string,
  id: string | number,
  key: string,
  updated_at: string,
  value: string,
|};

@translate()
export default class AssetCustomFields extends React.Component<*> {
  render(): ?React.Element<*> {
    const t: Function = this.props.t;
    const fields: Array<TypePropsAcf> = this.props.details.custom_fields;

    function parseJSON(json: TypePropsAcf): Object {
      let parsed: Object;

      try {
        parsed = JSON.parse(json.value);
      } catch (e) {
        parsed = {
          label: 'Lorem Ipsum',
          message: json.value,
        };
      }

      return parsed;
    }

    if (!fields.length) {
      return null;
    }

    return (
      <div>
        <h3>{t('general:trading_accounts.labels.custom_fields')}</h3>
        <table>
          <tbody>
            {fields.map((field, i) => {
              const parsedValue: Object = parseJSON(field);
              return (
                <React.Fragment key={field.id}>
                  <tr>
                    <td>
                      <b>{t(`general:labels.custom_field_label`, { fieldNumber: i + 1 })}:</b>
                    </td>
                    <td>{field.key}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{t(`general:labels.custom_field_help`, { fieldNumber: i + 1 })}:</b>
                    </td>
                    <td>{field.value}</td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}
